import { DEFAULT_PER_PAGE, FIRST_PAGE } from '@/utils/constants';

import {
  get, post, patch, del,
} from './helper';

export const getStoreList = async ({
  page = FIRST_PAGE,
  perPage = DEFAULT_PER_PAGE,
  withMenu = false,
}) => {
  const res = await get({
    url: `admin/stores?page=${page}&per_page=${perPage}`,
    data: { with_menu: withMenu },
  });
  const { data: { stores } = {}, link: { pagination } = {} } = res;
  return stores && pagination ? { stores, pagination } : res;
};

export const getStore = async (storeId) => {
  const res = await get({ url: `team/stores/${storeId}`, version: 0 });
  return res?.data || res;
};

export const createStore = async (data) => {
  const res = await post({ url: 'team/stores', data, version: 0 });
  return res?.data || res;
};

export const updateStore = async (storeId, data) => {
  const res = await patch({ url: `team/stores/${storeId}`, data, version: 0 });
  return res?.data || res;
};

export const deleteStore = async (storeId) => {
  const res = await del({ url: `team/stores/${storeId}`, version: 0 });
  return res?.data || res;
};

export const getMenuList = async (storeId) => {
  const res = await get({
    url: `admin/stores/${storeId}/menus`,
  });
  return res?.data || res;
};

export const getMenu = async (storeId, menuId) => {
  const res = await get({
    url: `admin/stores/${storeId}/menus/${menuId}`,
  });
  return res?.data || res;
};

export const createMenu = async (storeId, menuInfo) => {
  const res = await post({
    url: `admin/stores/${storeId}/menus`,
    data: menuInfo,
  });
  return res?.data || res;
};

export const updateMenu = async (storeId, menuId, menu) => {
  const res = await patch({
    url: `admin/stores/${storeId}/menus/${menuId}`,
    data: menu,
  });
  return res?.data || res;
};

export const deleteMenu = async (storeId, menuId) => {
  const res = await del({
    url: `admin/stores/${storeId}/menus/${menuId}`,
  });
  return res?.data || res;
};

export const getMenuItemList = async (storeId, menuId) => {
  const res = await get({
    url: `admin/stores/${storeId}/menus/${menuId}`,
  });
  return res?.data || res;
};

export const getMenuTemplate = async () => {
  const res = await get({ url: 'menu_models', version: 0 });
  return res?.data || res;
};

export default {
  getStoreList,
  getStore,
  createStore,
  updateStore,
  deleteStore,
  getMenuList,
  getMenu,
  createMenu,
  updateMenu,
  deleteMenu,
  getMenuItemList,
  getMenuTemplate,
};
